import { render } from "./AccountSettingsModal.vue?vue&type=template&id=1d4ddf0e&scoped=true"
import script from "./AccountSettingsModal.vue?vue&type=script&lang=js"
export * from "./AccountSettingsModal.vue?vue&type=script&lang=js"

import "./AccountSettingsModal.vue?vue&type=style&index=0&id=1d4ddf0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4ddf0e"]])

export default __exports__